import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import "./vee-validate";
import mainMixin from './mainMixins.js'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
window.$ = require('jquery')
window.JQuery = require('jquery')

Vue.use(VueSweetalert2);
Vue.prototype.$liff = window.liff
Vue.config.productionTip = false
Vue.mixin(mainMixin)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
